import { useQuery } from '@apollo/client';
import { Autocomplete, TextField } from '@mui/material';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import ErrorMessage from 'components/ErrorMessage';

import debounce from 'utils/debounce';

const SEARCH_INVESTMENT_ENTITIES_QUERY = gql(`
  query InvestmentEntities($text: String!) {
  search(text: $text) {
    investmentEntities {
      nodes {
        name
        id
        user  {
          id
          email
        }
      }
    }
  }
}
`);

const SearchInvestmentEntities: FC<{ onSelect: (investmentEntityId: string) => void }> = ({
  onSelect,
}) => {
  const { loading, error, data, refetch } = useQuery(SEARCH_INVESTMENT_ENTITIES_QUERY, {
    variables: {
      text: '',
    },
  });

  if (error) return <ErrorMessage error={error} refetch={refetch} />;

  const investmentEntities =
    data?.search.investmentEntities.nodes.map(i => ({
      id: i.id,
      label: `${i.name} (${i.user.email})`,
    })) || [];

  return (
    <>
      <br />
      <Autocomplete
        size="small"
        disablePortal
        options={investmentEntities as { id: string; label: string }[]}
        renderInput={params => (
          <TextField
            onChange={debounce(e => {
              refetch({ text: e.target.value });
            }, 500)}
            variant="outlined"
            {...params}
            label="InvestmentEntity"
          />
        )}
        loading={loading}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(event: any, newValue: { id: string; label: string } | null) => {
          if (newValue) onSelect(newValue.id);
        }}
      />
    </>
  );
};

export default SearchInvestmentEntities;
